import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/BookOnlinePage.css';

const services = [
  { id: 1, name: "Private Lesson (In-Studio)", duration: "45 mins", price: "$85" },
  { id: 2, name: "Private Lesson (In-Home)", duration: "45 mins", price: "$100" },
  { id: 3, name: "Recording & Mixing Session", duration: "3 hrs", price: "$300" },
  { id: 4, name: "Live Sound Engineering", duration: "Event-Based", price: "Custom Quote" }
];

const BookOnlinePage = () => {
  return (
    <div className="book-online-container">
      <h1>Book Online</h1>
      <p>Select a service to begin your booking process.</p>

      <div className="service-list">
        {services.map((service) => (
          <div key={service.id} className="service-card">
            <h3>{service.name}</h3>
            <p><strong>Duration:</strong> {service.duration}</p>
            <p><strong>Price:</strong> {service.price}</p>
            <Link to={`/book-service?name=${encodeURIComponent(service.name)}&duration=${encodeURIComponent(service.duration)}&price=${encodeURIComponent(service.price)}`} className="book-now-btn">
              Book Now
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookOnlinePage;